export const singlepost = () => {


    //Like system
    jQuery(document).ready(function ($) {
        var likedPosts = JSON.parse(localStorage.getItem('likedPosts') || '[]');

        $('.likes-post').each(function () {
            var $button = $(this);
            var postId = parseInt($button.data('postid'), 10);

            if (likedPosts.includes(postId)) {
                $button.addClass('liked');
            } else {
                $button.removeClass('liked');
            }
        });

        $(document).on('click', '.likes-post', function (e) {
            e.preventDefault();
            var $button = $(this);
            var postId = parseInt($button.data('postid'), 10);

            var index = likedPosts.indexOf(postId);
            var action;

            if (index === -1) {
                action = 'like';
            } else {
                action = 'unlike';
            }

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'toggle_post_like',
                    post_id: postId,
                    like_action: action
                },
                success: function (response) {
                    if (response.success) {
                        if (action === 'like') {
                            likedPosts.push(postId);
                            $button.addClass('liked');
                        } else {
                            likedPosts.splice(index, 1);
                            $button.removeClass('liked');
                        }
                        localStorage.setItem('likedPosts', JSON.stringify(likedPosts));

                        var $countEl = $button.find('.like-count');
                        if ($countEl.length > 0 && typeof response.data.like_count !== 'undefined') {
                            $countEl.text(response.data.like_count);
                        }
                    } else {
                        console.error(response.data);
                    }
                },
                error: function (xhr, status, error) {
                    console.error(error);
                }
            });
        });
    });


    jQuery(document).ready(function ($) {
        var shareKeys = {
            twitter: 'twitterSharedPosts',
            facebook: 'facebookSharedPosts',
            linkedin: 'linkedinSharedPosts'
        };

        $('.share-button').each(function(){
            var $button = $(this);
            var network = $button.data('network');
            var postId = parseInt($button.data('postid'), 10);
            var key = shareKeys[network];

            if (!key || !postId) return;

            var sharedPosts = JSON.parse(localStorage.getItem(key) || '[]');
            if (sharedPosts.indexOf(postId) !== -1) {
                $button.addClass('shared');
            }
        });

        $(document).on('click', '.share-button', function (e) {
            var $button = $(this);
            var network = $button.data('network');
            var postId = parseInt($button.data('postid'), 10);

            var key = shareKeys[network];
            var sharedPosts = JSON.parse(localStorage.getItem(key) || '[]');

            if (sharedPosts.indexOf(postId) === -1) {
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'increment_share_count',
                        post_id: postId,
                        network: network
                    },
                    success: function (response) {
                        if (response.success) {
                            sharedPosts.push(postId);
                            localStorage.setItem(key, JSON.stringify(sharedPosts));

                            var $counter = $button.find('.counter');
                            if ($counter.length > 0 && typeof response.data.share_count !== 'undefined') {
                                $counter.text(response.data.share_count);
                            }
                            $button.addClass('shared');
                        } else {
                            console.error(response.data);
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error(error);
                    }
                });
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".recommended-post-item-right").forEach(item => {
        const categories = item.querySelectorAll(".recommended-post-categories a");
        const titleLink = item.querySelector("h2 > a");

        
        if (categories.length <= 3 && titleLink) {
            titleLink.style.webkitLineClamp = "3";
            titleLink.style.webkitBoxOrient = "vertical";
            titleLink.style.overflow = "hidden";
            titleLink.style.display = "-webkit-box";
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
    let items = document.querySelectorAll(".recommended-post-item-right");

    function moveElements() {
        items.forEach(rightBlock => {
            let reviewInner = rightBlock.querySelector(".recommended-post-item-review-inner");
            if (!reviewInner) return;

            let parent = rightBlock.parentElement; 

            if (window.innerWidth <= 768) {
                parent.appendChild(reviewInner); 
            } else {
                rightBlock.appendChild(reviewInner); 
            }
        });
    }

    window.addEventListener("resize", moveElements);
    moveElements(); 
});